import axios from "axios"
import qs from "qs";

const ajaxURL = process.env.NODE_ENV === 'development'
    ? 'http://api.skgarantiya.ru/wp-admin/admin-ajax.php'
    : '/wp-admin/admin-ajax.php';

export function ajax(params = {}, callback) {
    try {
        axios.post(
            ajaxURL,
            qs.stringify(params),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
            }
        ).then(response => {
            if (callback) {
                callback(response.data, response)
            }
        }).catch(error => {
            if (callback) callback(null, error)
        });
    } catch (error) {
        if (callback) callback(null, error)
    }
}

export function ajaxDownload(params = {}, callback, fileName = 'output.csv') {
    try {
        axios.post(
            ajaxURL,
            qs.stringify(params),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                responseType: 'blob'
            }
        ).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url;
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
            if (callback) callback(response.data, response)
        }).catch(error => {
            console.error('Ошибка при скачивании файла:', error)
            alert('Ошибка при скачивании файла, подробня информация в консоли браузера')
        });
    } catch (error) {
        console.log(error)
    }
}

export function ensureNestedPath(obj, path) {
    if (obj === null) obj = {};

    const keys = path.split('.');
    let currentObj = obj;

    for (const key of keys) {
        if (currentObj === null) break;

        if (!currentObj.hasOwnProperty(key)) {
            currentObj[key] = {};
        }

        currentObj = currentObj[key];
    }
    return obj;
}


export function objectToOptions($object = {}, priorityObject = {}) {
    const options = Object.entries($object).map(([key, value]) => ({
        label: value.name ?? value,
        value: key
    }));

    // Сортировка опций на основе значения приоритета
    options.sort((a, b) => {
        const priorityA = priorityObject[a.value]?.priority ?? 0;
        const priorityB = priorityObject[b.value]?.priority ?? 0;
        return priorityA - priorityB;
    });

    return options;
}

export function isItemPresent(items, key, value) {
    if (!items || items.length === 0) return false;
    return items.some(item => item[key] === value || items.some(item => item === value));
}